const notificationAndResponseEn = {
  detail: {
    policy: {
      basicSection: 'Basic Information',
      breadcrumbPolicies: 'Notification Policies',
      columns: {
        status: 'Status',
        trigger: 'Trigger'
      },
      createTitle: 'Create Notification Policy',
      description: 'Description',
      edit: 'Edit',
      emptyMark: '–',
      loadError: 'Failed to load notification policy.',
      message: 'Message',
      messageDialog: {
        body: 'Body',
        bodyPlaceholder: 'Enter body…',
        subject: 'Subject',
        subjectPlaceholder: 'Enter subject…',
        title: 'Edit Message: {{trigger}}'
      },
      nameLabel: 'Name',
      notificationSettings: 'Notification Settings',
      recipientOptions: {
        assignee: 'Assignee',
        operator: 'Initiator'
      },
      recipients: 'Recipients',
      recipientsPlaceholder: 'Select recipients',
      saveAction: 'Save',
      saved: 'Saved.',
      statusDisabled: 'Disabled',
      statusEnabled: 'Enabled',
      taskTypes: {
        application: 'Submit Task',
        approval: 'Approval Task',
        confirmation: 'Confirmation Task',
        formInput: 'Form Task',
        todo: 'Todo Task'
      },
      titleLabel: 'Notification Policy',
      triggers: {
        end: 'End',
        start: 'Start'
      },
      unsupportedDomainSettings: 'Notification settings UI for this domain is not implemented yet (alert domain coming later).',
      viewTitle: 'Notification Policy Detail'
    }
  },
  forces: {
    gaForce: 'GA Force',
    hrForce: 'HR Force',
    itForce: 'IT Force'
  },
  policies: {
    columns: {
      description: 'Description',
      name: 'Name'
    },
    create: 'Add Policy',
    delete: 'Delete',
    emptyMessage: 'No notification policies found.'
  },
  rules: {
    assignDialog: {
      notSet: 'Not Set',
      saved: 'Notification policy assignment saved',
      title: 'Assign Notification Policy: {{packageName}}'
    },
    columns: {
      force: 'Force',
      notificationPolicy: 'Notification Policy',
      operationPackage: 'Operation Package',
      product: 'Product'
    },
    edit: 'Edit',
    emptyMessage: 'No notification rules found.',
    filters: {
      allForces: 'All Forces',
      allProducts: 'All Products',
      forcePlaceholder: 'Force',
      productPlaceholder: 'Product'
    },
    notSet: 'Not Set',
    searchPlaceholder: 'Search Operation Packages...'
  },
  tabs: {
    notificationChannels: 'Notification Channels',
    notificationPolicies: 'Notification Policies',
    notificationRules: 'Notification Rules',
    settings: 'Settings'
  },
  targetTabs: {
    alert: 'Alerts',
    businessPackage: 'Operation Packages'
  },
  title: 'Notification & Response'
};
export default notificationAndResponseEn;